/** @format */

export const themeActionType = {
  changeTheme: "CHANGE_THEME_COLOR",
};
